import * as Survey from "survey-react";

export const calculateProgress = function (
  chapter,
  survey,
  includeMarkedForLater = false
) {
  if (survey) {
    const chapterArray = survey.pages.filter(
      (element) =>
        element.chapter === chapter && !element.isEasterEgg && element.isVisible
    );
    const chapterAnswered = chapterArray.filter(
      (element) =>
        element.isAnswered ||
        (includeMarkedForLater && element.isMarkedForLater)
    );
    return parseFloat(
      ((chapterAnswered.length / chapterArray.length) * 100).toPrecision(2)
    );
  }
};

// total progress
export const calculateTotalProgress = function (survey) {
  const chapterOnePercentageComplete = calculateProgress(1, survey);
  const chapterTwoPercentageComplete = calculateProgress(2, survey);
  const chapterThreePercentageComplete = calculateProgress(3, survey);
  const chapterFourPercentageComplete = calculateProgress(4, survey);

  return parseFloat(
    (
      (chapterOnePercentageComplete * 1 +
        chapterTwoPercentageComplete * 2 +
        chapterThreePercentageComplete * 2 +
        chapterFourPercentageComplete * 2) /
      7
    ).toFixed(0)
  );
};

// translate question(s) on page into CRM value
export const surevyPageToCrmValue = function (page) {
  let answers = "";
  const noneElements = [
    "no_other_city",
    "no_experiences",
    "no_macallan_own",
    "no_macallan_like_to_own",
  ];
  page.questions.forEach(function (q) {
    // if slider question is empty - set the value to "3"
    if (q instanceof Survey.QuestionEmptyModel) {
      answers = q.value === undefined ? 3 : parseInt(q.value);
      // 'None' options sent as null
    } else if (q.name === "no_macallan_bought") {
      if (q.value) {
        answers = ["no"];
      }
    } else if (q.name === "whisky_macallan_only") {
      if (q.value) {
        answers = ["not_applicable"];
      }
    } else if (noneElements.indexOf(q.name) !== -1) {
      if (q.value) {
        answers = null;
      }
    } else if (q.selectedItem) {
      // single selection
      if (!q.crmId) return;
      answers += q.selectedItem.text;
      const valueIndex = q.visibleChoices.findIndex(
        (item) => item.value === q.value
      );
      answers = q.crmId[valueIndex];
      if (q.comment) answers += `|${q.comment}`;
    } else if (q.selectedItems) {
      if (!q.crmId) return;
      answers = [];
      q.selectedItems.forEach(function (answer) {
        if (!answer) return;
        const valueIndex = q.visibleChoices.findIndex(
          (item) => item.value === answer.value
        );
        let single = q.crmId[valueIndex];
        if (q.comment) single += `|${q.comment}`;
        answers.push(single);
      });
    } else if (q.value !== null && q.value !== undefined) {
      // free text
      answers += q.value;
    }

    //if (q.comment) answers += ` ${q.comment}`;
  });

  return answers;
};

// translate CRM value into question(s) on given page
export const crmValueToSurveyPage = function (page, answer, surveyMTC) {
  const noneElements = [
    "no_other_city",
    "no_experiences",
    "no_macallan_own",
    "no_macallan_like_to_own",
    "no_experiences",
  ];

  page.questions.forEach(function (q) {
    if (q.name === "whisky_macallan_only") {
      if (answer && answer[0] === "not_applicable") {
        surveyMTC.setValue(q.name, "1");
      }
    } else if (q.name === "no_macallan_bought") {
      if (answer && answer[0] === "no") {
        surveyMTC.setValue(q.name, "1");
      }
    } else if (
      q instanceof Survey.QuestionRadiogroupModel ||
      q instanceof Survey.QuestionDropdownModel
    ) {
      // 'None' specific option selected (radiogroup with one option)
      if (noneElements.indexOf(q.name) !== -1 && answer === null) {
        surveyMTC.setValue(q.name, "1");
        return;
      } else if (!q.crmId) return;
      let key = "";
      if (typeof answer === "string") {
        key = answer.split("|");
      }

      // if "other" selected
      if (key.length > 1 && key[0] === "other") {
        surveyMTC.setValue(q.name, "other");
        surveyMTC.setComment(q.name, key[1]);
      } else {
        const valueIndex = q.crmId.findIndex((item) => item === answer);
        if (valueIndex >= 0)
          surveyMTC.setValue(q.name, q.visibleChoices[valueIndex]?.value);
      }
    } else if (q instanceof Survey.QuestionCheckboxModel) {
      if (!q.crmId) return;
      if (answer === null) {
        surveyMTC.setValue(q.name, null);
        return;
      }
      const values = [];
      if (typeof answer === "string") answer = [answer];
      if (answer.length) {
        answer.forEach((a) => {
          let key = "";
          if (typeof a === "string") {
            key = a.split("|");
          }
          if (key.length > 1 && key[0] === "other") {
            values.push("other");
            surveyMTC.setComment(q.name, key[1]);
          } else {
            const valueIndex = q.crmId.findIndex((item) => item === a);
            if (valueIndex >= 0)
              values.push(q.visibleChoices[valueIndex]?.value);
          }
        });
        surveyMTC.setValue(q.name, values);
      }
    } else if (q instanceof Survey.QuestionTextModel) {
      surveyMTC.setValue(q.name, answer);
    } else if (q instanceof Survey.QuestionDropdownModel) {
      surveyMTC.setValue(q.name, answer);
    } else if (q instanceof Survey.QuestionEmptyModel) {
      // range slider - nouislider
      surveyMTC.setValue(q.name, answer);
    }
  });
};

export const currentPageIndex = function (survey) {
  return survey.pages.findIndex(
    (element) => element.name === survey.currentPage.name
  );
};

// get all the answered pages (page is marked as isAnswered and also is "visible")
export const getAnsweredPages = function (survey) {
  return survey.pages.filter(
    (element) => element.isAnswered && element.isVisible
  );
};

// Consumer level depends on question q_2_3
// pages - should have only the "answered pages" - calculated based on answer and visibility status
export const getConsumerLevel = function (pages, answers, levels) {
  const page = pages.find((element) => element.name === "q_2_3");

  if (answers && page && answers[page.crmId]) {
    const answer = answers[page.crmId].split("|");
    switch (answer[0]) {
      case "novice":
      case "other":
        return levels.novice;
      case "connoisseur":
        return levels.connoisseur;
      case "wide_depth":
        return levels.expert;
      default:
        return levels.novice;
    }
  }
  return levels.novice;
};

// find each question from "answers" and select the values
export const getMergedQuestionsAndAnswers = function (pages, answers, survey) {
  pages.forEach((page) => {
    if (page.crmId && typeof answers[page.crmId] !== "undefined") {
      const answer = answers[page.crmId];
      crmValueToSurveyPage(page, answer, survey);
      // TODO be sure that the answer is correctly set in the question?
      page.isAnswered = true;
    }
  });
};

export const setAppBackground = (background, opacity = 0.7) => {
  //this.setState({ background });
  document.body.style.setProperty(
    "--background",
    `url("/backgrounds/${background}")`
  );
  document.documentElement.style.setProperty("--background-opacity", opacity);
};

/**
 * Sets a cookie that doesn't expiry and can be accessed by all subdomains of the Macallan.
 *
 * @param cName
 *   String cookie name.
 * @param cValue
 *   String cookie value.
 */
export function setPermanentTopLevelCookie(cName, cValue) {
  document.cookie = `${cName}=${cValue};path=/;Domain=.themacallan.com;Max-Age=31536000`
}

/**
 * Gets a cookie.
 *
 * @param cName
 *   String cookie name.
 * @returns {string|null}
 */
export function getCookie(cName) {
  const cookieIdentifier = `${cName}=`
  const cookies = document.cookie.split(';')

  // eslint-disable-next-line no-restricted-syntax
  for (const cookie of cookies) {
    const trimmedCookie = cookie.trim()

    // Only check for identifier at the start of the string, and return the value without the identifier.
    if (trimmedCookie.indexOf(cookieIdentifier) === 0) {
      return trimmedCookie.substring(cookieIdentifier.length)
    }
  }

  return null
}
